import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../hooks/axios/useAxios";
import { documentUploadEndpointUrl } from "../../constants/api/endpoints";
import { toast } from "react-toastify";

interface SubmitDocumentParams {
  document_request_id?: string;
  file: File;
  title?: string,
  description?: string
}

export const useSubmitDocument = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ document_request_id, file, title, description }: SubmitDocumentParams) => {
      const formData = new FormData();
      formData.append('file', file);
      if (document_request_id) {
        formData.append('document_request_id', document_request_id);
      }
      if (title && description) {
        formData.append('title', title);
        formData.append('description', description);
      }

      const response = await axios.post(documentUploadEndpointUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      return response.data;
    },
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["documentRequests"] });
      toast.success("Document uploaded successfully");
    },
    onError: (error: Error) => {
      toast.error("Failed to upload document. Please try again.");
      console.error("Error submitting document:", error);
    },
  });
};